var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', _vm._g({
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.buttonClass,
    attrs: {
      "type": "button"
    }
  }, _vm.$listeners), [_vm._t("default", function () {
    return [_vm.loading && !_vm.icon ? _c('span', {
      class: _vm.iconClass
    }) : _vm._e(), _vm.icon ? _c('span', {
      class: _vm.iconClass
    }) : _vm._e(), _c('span', {
      staticClass: "p-button-label"
    }, [_vm._v(_vm._s(_vm.label || ' '))]), _vm.badge ? _c('span', {
      staticClass: "p-badge",
      class: _vm.badgeStyleClass
    }, [_vm._v(_vm._s(_vm.badge))]) : _vm._e()];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }